export default {
    // Region Name
    "上海1区": "shanghai_1",
    "香港1区": "hk_1",
    "北京3区": "beijing_3",
    "北京1区": "beijing_1",
    "上海3区": "region_cn_shanghai_3",
    "上海3区(Basic)": "region_cn_shanghai_7",
    "上海3区(basic)": "region_cn_shanghai_7",
    "上海3区(VPC)": "shanghai3_districtVPC",
    "香港2区(VPC)": "region_cn_hongkong_2",
    "北京6区(VPC)": "beijing6_districtVPC",
    "北京6区": "region_cn_beijing_6",
    "上海2区(VPC)": "shanghai2_districtVPC",
    "北京1区(VPC)": "beijing1_vpc",
    "新加坡1区(VPC)": "singapore-1-vpc-new",
    "广州1区(VPC)": "cn-guangzhou-1",
    "武汉1区(VPC)": "cn-wuhan-1",
    "俄罗斯1区(VPC)": "eu-east-1",
    "俄罗斯1区（VPC）": "eu-east-1",
    "台北1区(VPC)": "taipei1_districtVPC",
    "青岛1区(VPC)": "cn-qingdao-1",
    "北京金融": "cn-beijing-fin",
    "上海金融": "cn-shanghai-fin",
    '华北1（政务）': 'cn-north-1-gov',
    '华北1(政务)': 'cn-north-1-gov',
    '青岛研发1区(VPC)': 'cn-qingdaodev-1',
    '华中1': 'cn-central-1',
    '西南1': 'cn-southwest-1',

    "华北1（北京）": "cn_north_1_beijing", //原：北京6区(VPC)
    "华北金融1（北京）": "cn_north_finance_1_beijing", //原：北京金融
    "华北政务1（北京）": "cn_north_government_1_beijing", //原：华北1(政务)
    "华东1（上海）": "cn_east_1_shanghai", //原：上海2区(VPC)
    "华东金融1（上海）": "cn_east_finance_1_shanghai", //原：上海金融
    "华中1（武汉）": "cn_central_1_wuhan", //原：华中1
    "华南1（广州）": "cn_south_1_guangzhou", //原：广州1区(VPC)
    "西南1（重庆）": "cn_southwest_1_chongqing", //原：西南1
    "香港": "hong_kong", //原：香港2区(VPC)
    "台北": "taipei", //原：台北1区(VPC)
    "自用（青岛）": "self_use_qingdao", //原：青岛1区(VPC)
    "新加坡": "singapore", //原：新加坡1区(VPC)
    "俄罗斯（莫斯科）": "russia_moscow", //原：俄罗斯1区(VPC)
    "自用（青岛2）": "self_use_qingdao2", //原：青岛研发1区(VPC)
    "华东2（上海）": "cn_east_2_shanghai", //原：上海3区(VPC)
    "西北1区（庆阳）": "cn-northwest-1", //西北1区（庆阳）
    "西北2区（自用）": "cn-northwest-2", //西北2区（自用）
    "西北3区（宁夏）": "cn-northwest-3", //西北3区（宁夏）
    "华北专属1区（天津-小米）": "cn-north-vip1",
    "庆阳1区(测试)": "cn-qingyangtest-1", //庆阳1区(测试)

    // 'cn-central-1': 'cn-central-1',
    'cn-shanghai-7': 'region_cn_shanghai_7',
    // 'cn-north-1-gov': 'cn-north-1-gov',
    "cn-shanghai-1": "shanghai_1",
    "cn-hongkong-1": "hk_1",
    "cn-beijing-3": "cn-beijing-3",
    "cn-beijing-1": "beijing_1",
    // "cn-shanghai-3": "shanghai3_districtVPC",
    // "cn-hongkong-2": "region_cn_hongkong_2",
    // "cn-beijing-6": "beijing6_districtVPC",
    // "cn-shanghai-2": "shanghai2_districtVPC",
    "cn-beijing-1-new": "beijing1_vpc",
    // "ap-singapore-1": "singapore-1-vpc-new",
    // "cn-guangzhou-1": "cn-guangzhou-1",
    "cn-wuhan-1": "cn-wuhan-1",
    // "eu-east-1": "eu-east-1",
    // "cn-taipei-1": "taipei1_districtVPC",
    // "cn-qingdao-1": "cn-qingdao-1",
    // "cn-beijing-fin": "cn-beijing-fin",
    // "cn-shanghai-fin": "cn-shanghai-fin",
    // 'cn-southwest-1': 'cn-southwest-1',
    // 'cn-qingdaodev-1': 'cn-qingdaodev-1',

    // 请到旧版国际化平台添加词条
    "cn-shanghai-3": "cn_east_2_shanghai",
    "cn-beijing-6": "cn_north_1_beijing",
    "cn-beijing-fin": "cn_north_finance_1_beijing",
    "cn-north-1-gov": "cn_north_government_1_beijing",
    "cn-shanghai-2": "cn_east_1_shanghai",
    "cn-shanghai-fin": "cn_east_finance_1_shanghai",
    "cn-central-1": "cn_central_1_wuhan",
    "cn-guangzhou-1": "cn_south_1_guangzhou",
    "cn-southwest-1": "cn_southwest_1_chongqing",
    "cn-hongkong-2": "hong_kong",
    "cn-taipei-1": "taipei",
    "cn-qingdao-1": "self_use_qingdao",
    "ap-singapore-1": "singapore",
    "ap-singapore-2": "singapore2",
    "eu-east-1": "russia_moscow",
    "cn-qingdaodev-1": "self_use_qingdao2",
    "cn-northwest-1": "cn_northwest_1_qingyan",
    "cn-northwest-2": "cn_northwest_2_qingyan",
    "cn-northwest-3": "cn_northwest_3_ningxia",
    "cn-north-vip1": "cn_north_vip1_xiaomi",
    "cn-qingyangtest-1": "cn_qingyangtest_1", //庆阳1区(测试)

    "all": "all_regions", //"全部区域",
    "cn": "area_china", //"国内",
    "ap": "area_asia", //'亚太',
    "eu": "area_europe", //'欧洲'

} as any;
